<div class="add-edit-user-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title
            *ngIf="editMode">{{ 'EditUser'|translate }}</h2>
        <h2 mat-dialog-title
            *ngIf="!editMode">{{ 'AddNewUser'|translate }}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button"
                mat-raised-button
                class="icon-button close-button"
                mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <ng-container [ngTemplateOutlet]="form"></ng-container>
    </mat-dialog-content>
</div>

<ng-template #form>
    <form [formGroup]="userForm"
          class="ups-form">
        <div class="form-body">
            <mat-form-field>
                <mat-label>{{ 'FirstName'|translate }}</mat-label>
                <input matInput
                       type="text"
                       required
                       formControlName="FirstName"
                       autocomplete="off">
                <mat-error *ngIf="userForm.controls.FirstName.errors?.required">
                    <span *ngIf="userForm.controls.FirstName.errors?.required">
                        {{ 'FirstNameRequired'|translate }}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ 'LastName'|translate }}</mat-label>
                <input matInput
                       type="text"
                       required
                       formControlName="LastName"
                       autocomplete="off">
                <mat-error *ngIf="userForm.controls.LastName.errors?.required">
                    <span *ngIf="userForm.controls.LastName.errors?.required">
                        {{ 'LastNameRequired'|translate }}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ 'Username'|translate }}</mat-label>
                <input matInput
                       type="text"
                       required
                       formControlName="UserName"
                       autocomplete="off"
                       [readonly]="editMode ? 'true' : null">
                <mat-error *ngIf="userForm.controls.UserName.errors?.required">
                    <span *ngIf="userForm.controls.UserName.errors?.required">
                        {{ 'userNameRequired' | translate }}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ 'Email'|translate }}</mat-label>
                <input matInput
                       type="text"
                       formControlName="Email"
                       required
                       autocomplete="off">
                <mat-error *ngIf="userForm.controls.Email.errors">
                    <span *ngIf="userForm.controls.Email.errors">
                        {{ 'EnterValidEmail'|translate }}
                    </span>
                </mat-error>
            </mat-form-field>

            @if (shouldAllowPasswordUpdate) {
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <mat-label>{{ 'EnterPassword'|translate }}</mat-label>
                    <input matInput
                           type="password"
                           formControlName="Password"
                           (focus)="passwordFocus()"
                           (focusout)="passwordFocusOut()"
                           autocomplete="off"
                           [required]="!editMode">
                    <!-- pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@#$%^&*£€!{}()~`|:\[\]\\\/\<\>+',?._-]{8,}$" -->
                    <mat-hint>{{ 'Password8char'|translate }}</mat-hint>
                    <mat-error *ngIf=" userForm.controls.Password.errors?.required">
                    <span *ngIf=" userForm.controls.Password.errors?.required">
                        {{ 'PasswordRequired'|translate }}
                    </span>
                    </mat-error>
                    <mat-error *ngIf="validationMessages">
                    <span *ngIf="validationMessages">
                        {{ 'Password8char'|translate }}
                    </span>
                    </mat-error>
                    <!-- <mat-error *ngIf=" userForm.controls.Password.errors">
                        <span *ngIf=" userForm.controls.Password.errors">
                            {{'Password8char'|translate}}
                        </span>
                    </mat-error> -->
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'ConfirmPassword'|translate }}</mat-label>
                    <input matInput
                           type="password"
                           formControlName="ConfirmPassword"
                           [required]=" isPasswordChanged ? true : null"
                           autocomplete="off">
                    <mat-error *ngIf=" userForm.controls.ConfirmPassword.errors?.required">
                    <span *ngIf=" userForm.controls.ConfirmPassword.errors?.required">
                        {{ 'ConfirmPasswordRequired'|translate }}
                    </span>
                    </mat-error>
                    <mat-error *ngIf="userForm.controls.ConfirmPassword.errors?.mustMatch">
                    <span *ngIf="userForm.controls.ConfirmPassword.errors?.mustMatch">
                        {{ 'PasswordConfirmPasswordNotEqual'|translate }}
                    </span>
                    </mat-error>
                </mat-form-field>
            }

            <mat-form-field>
                <mat-label>{{ 'Location'|translate }}</mat-label>
                <mat-select formControlName="DefaultLocation"
                            required>
                    <mat-option *ngFor="let location of locations"
                                value="{{location.ContactId | lowercase}}">
                        {{ location.CompanyName }}, {{ location.StreetAddress }}, {{ location.City }}, {{ location.State }},
                        {{ location.Zip }},
                        {{ location.Country }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="userForm.controls.DefaultLocation.errors?.required">
                    <span *ngIf="userForm.controls.DefaultLocation.errors?.required">
                        {{ 'DefaultShipFromLocationRequired'|translate }}
                    </span>
                </mat-error>
            </mat-form-field>

            <div class="options">
                <button type="button"
                        mat-raised-button
                        (click)="openEditLocation()"
                        class="alternative-button add-location">
                    {{ 'AddLocation'|translate }}
                </button>

                <button (click)="removeConfirmation()"
                        *ngIf="user.UserName!==user.CustomerId && currentUser?.userId !== user.UserId"
                        class="alternative-button"
                        mat-raised-button
                        type="button">
                    {{ 'RemoveUser'|translate }}
                </button>

                @if (editMode && !shouldAllowPasswordUpdate) {
                    <button type="button"
                            color="primary"
                            (click)="sendResetPasswordEmail($event)"
                            class="alternative-button"
                            mat-raised-button>{{ 'SendUserResetPasswordEmail' | translate }}
                    </button>
                }
            </div>

            <div class="checkboxes">
                <mat-checkbox formControlName="IsAdmin">{{ 'SetAsAdministrator'|translate }}</mat-checkbox>
                <mat-checkbox formControlName="IsAPIUser">{{ 'APIUser'|translate }}</mat-checkbox>
                <mat-checkbox formControlName="IsGuest">{{ 'SetGuest'|translate }}</mat-checkbox>
            </div>
            <div class="sections"
                 *ngIf="userForm.controls.IsGuest.value">
                <div class="section">
                    <label>{{ 'shipTo'|translate }}</label>
                    <mat-radio-group class="radio-buttons"
                                     formControlName="IsGuestAddressBook">
                        <mat-radio-button value="true">{{ 'Open'|translate }}</mat-radio-button>
                        <mat-radio-button value="false">{{ 'Locked'|translate }}</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="section">
                    <label>{{ 'shipFrom'|translate }}</label>
                    <mat-radio-group class="radio-buttons"
                                     formControlName="IsGuestShipFrom">
                        <mat-radio-button value="true">{{ 'Open'|translate }}</mat-radio-button>
                        <mat-radio-button value="false">{{ 'Locked'|translate }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <mat-form-field *ngIf="userForm.controls.IsGuest.value">
                <mat-label>{{ 'GuestContact'|translate }}</mat-label>
                <mat-select formControlName="GuestContactID"
                            [required]="userForm.controls.IsGuest.value ? true : null">
                    <mat-option *ngFor="let location of guestContacts"
                                value="{{location.ContactId | lowercase}}">
                        {{ location.CompanyName }}, {{ location.StreetAddress }}, {{ location.City }}, {{ location.State }},
                        {{ location.Zip }},
                        {{ location.Country }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="userForm.controls.GuestContactID.errors?.required">
                    <span *ngIf="userForm.controls.GuestContactID.errors?.required">
                        {{ 'GuestContactRequired'|translate }}
                    </span>
                </mat-error>
            </mat-form-field>

        </div>

        <div class="form-footer">
            <div class="form-actions">
                <button type="submit"
                        mat-raised-button
                        class="form-action"
                        [disabled]="!userForm.valid"
                        (click)="updateUser()"
                        *ngIf="editMode">
                    {{ 'Save'|translate }}
                </button>
                <button type="submit"
                        mat-raised-button
                        class="form-action"
                        [disabled]="!userForm.valid"
                        (click)="saveUser()"
                        *ngIf="!editMode">
                    {{ 'Save'|translate }}
                </button>
            </div>
        </div>
    </form>
</ng-template>
